<template>
  <div class="device-statistics-page">
    <div class="head_body">
      <el-form ref="form" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="6">
            <el-form-item :label="$t('device.device_number')">
              <el-select
                v-model="lamp_id"
                filterable
                remote
                :placeholder="$t('device.please_device_number')"
                :remote-method="searchDeviceList"
                :loading="keywordLoading"
                style="width:100%"
                >
                <el-option
                  v-for="item in deviceList"
                  :key="item.lamp_id"
                  :label="item.number+'('+item.name+')'"
                  :value="item.lamp_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('control.select_month')">
              <el-date-picker
                v-model="yearMonth"
                type="month"
                value-format="yyyy-MM"
                :placeholder="$t('control.select_month')"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="search-btn-box">
            <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div v-if="chartData.series.length" class="box-chart">
        <div id="statisticsChart" class="charts-box" :style="{width: '100%', height: '100%'}" />
      </div>
      <div v-else class="box-chart-none">{{$t('system.no_data')}}</div>
    </div>
 
  </div>
</template>
<script>
import statisticsApi from "@/api/device/statistics";
import moment from "moment";
export default {
  data() {
    return {
      keywordLoading: false,
      lamp_id: '',
      deviceList: [],
      yearMonth: moment(new Date()).format("YYYY-MM"),
      chartData: {
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de',
          '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#449dde',
          '#fbb726', '#c05050', '#4bacc6', '#8064a2', '#f79646',
          '#ff0000', '#00ff00', '#0000ff', '#ff00ff', '#ffff00',
          '#00ffff', '#800000', '#008000', '#000080', '#800080',
          '#808000', '#008080', '#808080', '#ff99cc', '#ffcc99'],
        grid: {
          top: '10%',
          left: '1%',
          right: '2%',
          bottom: '6%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#0c82fe'
            }
          }
        },
        legend: {
          data: []
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: []
        }],
        yAxis: [{
          type: 'value'
        }],
        series: []
      }
    };
  },
  methods: {
    searchDeviceList(keyword) {
      if (keyword) {
        this.keywordLoading = true
        statisticsApi.getStatisticsLamp({
          number: keyword
        }).then((res) => {
          if (res.data.code === 1000) {
            this.keywordLoading = false;
            this.deviceList = res.data.data;
          }
        })
      } else {
        this.deviceList = []
      }
    },
    headSearch() {
      if(!this.lamp_id){
        return this.$message.error(this.$t('device.please_device_number'));
      }
      if(!this.yearMonth){
        return this.$message.error(this.$t('control.select_month'));
      }
      this.getChartData()
    },
    getChartData() {
      const that = this
      let lamp_id = that.lamp_id
      const date = that.yearMonth
      statisticsApi.getElectricityConsumptionStatistics({
        lamp_id: lamp_id,
        date: date
      }).then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data
          if(resData&&resData.data&&resData.data.length){
            let legendData = []
            let seriesData = []
            for(let i=0;i<resData.data.length; i++){
              legendData[i] = resData.data[i].name
              seriesData[i] = {
                name: resData.data[i].name,
                type: 'line',
                lineStyle: {
                  width: 2
                },
                data: resData.data[i].value
              }
            }
            that.chartData.legend.data = legendData
            that.chartData.xAxis[0].data = resData.date
            that.chartData.series = seriesData
            that.drawChart()
          } else {
            this.$message.error($t('system.no_data'));
          }
        }
      })

    },
    drawChart() {
      var statisticsChart = this.$echarts.init(document.getElementById('statisticsChart'))
      statisticsChart.clear()
      statisticsChart.setOption(this.chartData)
    }
  }
};
</script>

<style lang='less'>
.device-statistics-page{
  .box-chart{
    width:100%;
    height:670px;
  }
  .box-chart-none{
    font-size: 24px;
    width:100%;
    height:560px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }
} 

</style>
      